let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ap3Co")).then(() => parcelRequire('96cpV'));